/**
 * created by lei lei
 * 视频本地上传
 */
import React, {Component} from 'react';
import {Icon, Tooltip, InputNumber,message,Switch,Modal} from "antd";
import './VideoLocally.scss'
import UploadWall from "../../../../components/upload/UploadWall";
import {VIDEO_TYPE_ORIGINAL, VIDEO_TYPE} from "../../../../constants";
import ChunkUpload from "../../../../components/upload/ChunkUpload";
import {Scrollbars} from "react-custom-scrollbars";
import BaseComponent from "../../../../base/BaseComponent";
import {unitConvert} from "../../../../utils";
import leftSideIcon from "../image/leftside.png";
import leftCenterIcon from "../image/leftCenter.png";
import rightCenterIcon from "../image/rightCenter.png";
import centerIcon from "../image/center.png";
import NormalFileItem from "../../../../components/upload/fileItem/VideoNormalFileItem";

export default class VideoLocally extends BaseComponent {

    static defaultProps = {
        onChange: ()=>{}
    };

    constructor(props) {
        super(props);
        this.state = {
            cssWidth: this.sysConfigGetValueByKey("editor.content.video.insert.width", "500"),
            cssHeight: 0,
            cssAutoPlay: eval(this.sysConfigGetValueByKey("editor.content.video.insert.autoplay", "false")),
            fileList: [],
            previewVisible:false,
            float: null,
            videoMaxSize: this.sysConfigGetValueByKey("Upload.max.videoSize", "500")*1,
        };
    }

    onChange = (info) => {
        info.fileList = info.fileList.map(item => {
            // 取决于需要什么数据填入fileList
            if (item.uid === info.file.uid) {
                if(info.file.response && info.file.response.data){
                    //分片上传是走的自己封装的接口 所以返回值只有data
                    //直接上传走的是antd的接口，所以返回值还有一个data属性包裹着的。这里主要是兼容两种返回值
                    info.file.response = {...info.file.response.data, ...info.file.response};
                    item.response = info.file.response;
                }
                item.uid = info.file.uid;
                item.ext = info.file.response && info.file.response.suffix;
                item.url = info.file.response && info.file.response.path;
                item.path = info.file.response && info.file.response.path;
                item.mp4Path = info.file.response && info.file.response.mp4Path;
                item.name = info.file.response && info.file.response.name;
                item.type = "video";
                item.isChunk = true;
                item.status = info.file.status;
            }
            return item;
        });
        this.props.onChange(JSON.parse(JSON.stringify(info.fileList)));
        this.setState({
            fileList: info.fileList
        })
    };

    handleRemove =  file => {
        let fileList = this.state.fileList.filter(item => item.uid !== file.uid);
        this.props.onChange(JSON.parse(JSON.stringify(fileList)));
        this.setState({
            fileList
        });
    };


    handlePreview = file => {
        if(file && file.url){
            this.setState({
                previewImage: file.url,
                previewVisible: true,
            });
        }
    };

    beforeUpload = async file => {
        let res = VIDEO_TYPE.find(item=>file.name.endsWith(item));
        let sizeValue =  file.size / 1024 / 1024
        return new Promise((resolve, reject) => {
            if(res){
                if(sizeValue < this.state.videoMaxSize){
                    resolve()
                }else {
                    message.error(`文件大小不能超过${this.state.videoMaxSize}MB！`);
                    reject();
                }
            }else{
                message.error('暂不支持该文件类型！');
                reject();
            }
        });
    };

    render() {
        let {fileList} = this.state;
        return (
            <div className="lightLoupe">
                {this.header()}
                {this.main()}
                {fileList && fileList.length > 0 &&  this.footer()}
            </div>
        )
    }

    header() {
        let {fileList} = this.state;
        let fileLength = fileList ? fileList.length : 0;
        let allSize = 0;
        fileList && fileList.map(file=>{
            allSize += file.originFileObj.size;
        });
        let baseStyle = {marginLeft:15,cursor:"pointer"};
        let defaultStyle = {...baseStyle,border:"1px solid #FFF"};
        let checkedStyle = {...baseStyle,borderTop:"solid 1px #000",borderLeft:"solid 1px #000",borderRight:"solid 1px #DCDCDC",borderBottom:"solid 1px #DCDCDC"};
        let text = this.sysConfigGetValueByKey("editor.video.upload.dialog.remind.txt", `视频格式要求：${VIDEO_TYPE_ORIGINAL.join("，")}`);
        return (
            <div className="pictureFormat">
                <div className={"text-pointer"} style={{maxWidth:400,color:"#F56C6C"}}>
                    <Tooltip placement="topLeft" title={text}>{text}</Tooltip>
                </div>
                <div>
                    {fileLength > 0 && <span style={{color:"#9b9999"}}>共<span style={{margin:"0 5px"}}>{fileLength}</span>个（{unitConvert(allSize)}）</span>}
                    <span style={{color:"#000",marginLeft:15}}>视频浮动方式：</span>
                    <Tooltip placement="top" title={"无浮动"} onClick={()=>{this.setState({float:null})}}><img style={this.state.float===null?checkedStyle:defaultStyle} src={leftSideIcon}/></Tooltip>
                    <Tooltip placement="top" title={"左浮动"} onClick={()=>{this.setState({float:"left"})}}><img style={this.state.float==="left"?checkedStyle:defaultStyle} src={leftCenterIcon}/></Tooltip>
                    <Tooltip placement="top" title={"右浮动"} onClick={()=>{this.setState({float:"right"})}}><img style={this.state.float==="right"?checkedStyle:defaultStyle} src={rightCenterIcon}/></Tooltip>
                    <Tooltip placement="top" title={"居中独占一行"} onClick={()=>{this.setState({float:"center"})}}><img style={this.state.float==="center"?checkedStyle:defaultStyle} src={centerIcon}/></Tooltip>
                </div>
            </div>
        )
    }

    footer() {
        // let defaultWidth = this.sysConfigGetValueByKey("editor.content.pic.insert.width", "500");
        return (
            <table style={{marginBottom:10}} width={"100%"} cellSpacing={0} cellPadding={0} border={0}><tbody><tr>
                <td>
                    <div className="seat">
                        <div>宽度（px）</div>
                        <InputNumber min={1} max={100000} defaultValue={parseInt(this.state.cssWidth)} onChange={(value)=>{this.inputNumberOnChange(value, 'cssWidth')}} />
                        {/*<div style={{marginLeft: 10}}>高度（px）</div>*/}
                        {/*<InputNumber min={0} max={100000} defaultValue={0} onChange={(value)=>{this.inputNumberOnChange(value, 'cssHeight')}} />*/}
                    </div>
                </td>
                <td width={140}>
                    <div className="watermark">
                        <div style={{marginRight:10}}>自动播放设置</div>
                        <Switch checkedChildren="开" unCheckedChildren="关" defaultChecked={this.state.cssAutoPlay} onChange={(value)=>{this.inputNumberOnChange(value, 'cssAutoPlay')}}/>
                    </div>
                </td>
            </tr></tbody></table>
        )
    }

    main() {
        const {fileList} = this.state;
        // if(fileList.length > 0) {
        return (
            <div className='noFile'>
                <div style={{height: '100%', width: '100%',}} onClick={()=>{
                    // let dom = $("input[type='file']").click();
                }}>
                    <Scrollbars
                        autoHeight={true}
                        autoHeightMax={300}
                    >
                        <div style={{paddingRight:10}}>
                            {this.upload()}
                        </div>
                    </Scrollbars>
                    {fileList.length === 0 &&
                    <table cellPadding={0} cellSpacing={0} border={0} width={"100%"} height={"80%"}><tbody><tr><td valign={"middle"} align={"center"}>
                        <div className="noPictures"></div>
                        <div onClick={()=>this.uploadWall && this.uploadWall.uploadDisplayBtnClick()} style={{cursor:"pointer",borderRadius: 8,width:100,padding:5,border:`1px solid ${this.themeBgColor}`, color:`${this.themeBgColor}`}}>
                            点击选择视频
                        </div>
                    </td></tr></tbody></table>}
                </div>
            </div>
        )
    }

    upload() {
        const {fileList} = this.state;
        return (
            <UploadWall
                ref={uploadWall=>this.uploadWall = uploadWall}
                showUploadDisplayBtn={true}
                accept={"."+VIDEO_TYPE_ORIGINAL.join(",.")}
                multiple={true}
                action="/storage/uploadFile"
                fileList={fileList}
                style={{padding:'unset'}}
                uploadBtnComponent={(size)=>{
                    return <table style={{background:"#f4f6fc",border:"1px solid #f1f3f4",cursor:"pointer"}} cellSpacing={0} cellPadding={0} width={size} height={size}><tbody><tr><td valign={"middle"} align={"center"}>
                        <Icon type={"plus"} style={{color:"#5a5858",fontSize:16,margin:10}}></Icon><br/>
                        <span style={{color:"#9ca0a3",fontSize:14}}>点击上传</span>
                    </td></tr></tbody></table>
                }}
                isSyncModifiedFileName={true}   //通过服务端修改文件名
                customRequest={new ChunkUpload({
                    checkFileURL:"/storage/checkFile",
                    checkChunkURL:"/storage/checkChunk",
                    uploadChunkURL:"/storage/uploadChunk",
                    chunkUploadOverURL:"/storage/chunkIsUploadOver",
                    mergeChunksURL:"/storage/mergeChunk",
                    fileError:(md5, mergeResult, newFile)=>{
                        Modal.error({
                            title: '上传错误！',
                            content: <div>文件  <span style={{color: 'red'}}>{mergeResult.name}</span>上传错误！</div>,
                            onOk: () => {
                                let newFiles = fileList.filter(item=>item.md5 !== md5);
                                this.setState({fileList: newFiles})
                            }
                        });
                    }
                }).start}
                icons={["eye", "download", "delete"]}
                fileItemComponent={NormalFileItem}
                onEditFileNameCall={(file, fileName)=>{
                    this.state.fileList.forEach(item=>{
                        if(item.id === file.id) {
                            item.name = fileName
                        }
                    });
                    this.setState({},()=>{
                        this.props.onChange(this.state.fileList)
                    });
                }}
                showUploadBtn={fileList.length !== 0}
                uploadBtnName={"点击上传"}
                beforeUpload={this.beforeUpload}
                onChange={this.onChange}
                onRemove={this.handleRemove}
                onPreview={this.handlePreview}
            />
        )
    }

    inputNumberOnChange (value, type='width') {
        this.state[type] = value;
        // this.setState({});
    }
}